import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;

  & > button {
    width: 23rem;
    margin-right: 1.5rem;
  }
`;
